import camelCase from 'lodash/camelCase';
import { stemmer } from 'stemmer';

/**
 * Stem each part of a camelCase string separately
 * @example `computeComputer` -> `computcomput`
 */
export function stemParts(input: string) {
  const parts = camelCase(input).split(/(?=[A-Z])/);
  const stemmedParts = parts.map((part) => stemmer(part.toLowerCase()));
  return stemmedParts.join('');
}
